



















































import {Component, Prop, Vue} from 'vue-property-decorator';
import TitleBar from '@/components/layout/TitleBar.vue';
import {SET_LAYOUT_CONFIG} from "@/store/layout_module";
import BoxTile from '@/components/ui/BoxTile.vue';
import ProgressContinuous from '@/components/ui/goal-charts/ProgressContinuous.vue';
import ProgressAnswer from '@/components/ui/goal-charts/ProgressAnswer.vue';
import GlobalMixin from "@/mixins";

@Component({
  components: {
    ProgressAnswer,
    ProgressContinuous,
    BoxTile,
    TitleBar
  },
})
export default class GoalInfo extends GlobalMixin {

  @Prop()
  public id!: string;

  get debug() {
    return this.$store.getters.debug;
  }

  get goalDetails() {
    return this.$store.getters.goalDetailById(this.id);
  }

  get latestGoal() {
    if (this.$store.state.data) {
      if (this.$store.state.data.goals && this.$store.state.data.goals.length) {
        return this.$store.state.data.goals[0].goalKey
      }
      return 'latest';
    }
    return 'latest';
  }

  get goalTitle() {
    const goal = this.goalDetails;
    if (goal) {
      if (goal.details) {
        return goal.details.title;
      }
      return goal.title;
    }
    return '';
  }

  get goalHasQuestions() {
    const goal = this.goalDetails;
    if (goal) {
      return goal.details && goal.details.promptGoalCards && goal.details.promptGoalCards.length;
    }
    return false;
  }

  get goalHasBooklets() {
    const goal = this.goalDetails;
    if (goal) {
      return goal.details && goal.details.promptGoalBooklets && goal.details.promptGoalBooklets.length;
    }
    return false;
  }

  get goalHasDescription() {
    const goal = this.goalDetails;
    if (goal) {
      return goal.details && goal.details.description
    }
    return false;

  }

  get entries() {
    const goal = this.goalDetails;
    if (goal) {
      return goal.entries.slice(0, 5);
    }
    return [];
  }

  get websiteId() {
    return this.$store.state.data ? this.$store.state.data.website_id : '';
  }

  get goalWeeks() {
    if (this.goalDetails.months_range) return this.$tc('AGE.MONTHS_SINGULAR', this.goalDetails.months_range)
    return this.$t('AGE.WEEKS_SINGULAR', {weeks: this.goalDetails.weeks_range})
  }

  public updatePageTitle() {
    /**
     * If the id is not `latest`, then we are viewing a past goal
     * So the TitleBar should display the back button linking to Past Goals
     */

    if (this.goalDetails) {

      this.$store.commit('layout/' + SET_LAYOUT_CONFIG, {
        showPageTitle: true,
        showBackButton: this.id !== this.latestGoal,
        pageTitle: 'GOAL.PAGE_TITLE',
        pageTitleParams: {weeks: this.goalWeeks},
        backButtonLink: {name: 'dashboard.goals.past'},
        showFooterNav: true
      })
    }
    else {
      this.$store.commit('layout/' + SET_LAYOUT_CONFIG, {
        showPageTitle: true,
        showBackButton: this.id !== this.latestGoal,
        pageTitle: 'GOAL.PAGE_TITLE_FALLBACK',
        pageTitleParams: null,
        backButtonLink: {name: 'dashboard.goals.past'},
        showFooterNav: true
      })
    }
  }

  public onClickLearnMore(label: string) {
    this.track('Goal Learn More Click', label, this.goalDetails.goal, this.websiteId);
  }

  private updated() {
    this.updatePageTitle();
  }

  private mounted() {
    this.updatePageTitle();
  }
}
